import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

const NAMESPACE = 'http://www.w3.org/1999/xlink'

export default class Icon extends Component {
  componentDidUpdate () {
    // this is needed for Safari, won't redraw the use element otherwise
    if (this._useElement) {
      this._useElement.setAttributeNS(NAMESPACE, 'href', '#' + this.props.icon)
    }
  }

  render () {
    return (
      <svg
        className={classnames(this.props.className || 'icon', {
          'icon--line': this.props.type === 'line'
        })}
      >
        <use
          ref={e => {
            if (e) {
              this._useElement = e
            }
          }}
          xlinkHref={'#' + this.props.icon}
        />
      </svg>
    )
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['line'])
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Icon.js